import { SET_RESTAURANT_PAYMENTS } from "../restaurant/constants";

const initState = [];

export default function restaurantPaymentReducer(state = initState, action) {
  switch (action.type) {
    case SET_RESTAURANT_PAYMENTS:

      return action.payload;

    default:
      return state;
  }
}
